import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import {
  Button,
  CookieUtil,
  Form,
  Gutter,
  Input,
  Grid,
  GridRow,
  GridColumn,
  SmallHeader,
  CondensedLarge,
  AxiomLogo,
  Loader,
  PageContext,
} from '@axiom/ui';

import sideImageUrl from '../public/svg/spyglass.svg?url';
import { WindowUtil } from '../utils/WindowUtil';
import { DefaultLayout } from '../layouts/DefaultLayout/DefaultLayout';
import { readAuthRequestSchema } from '../api/auth-api';

const { getFullRedirect, getUrlWithRelayState } = WindowUtil;

export const EnterEmailPage = () => {
  const { setTitle } = useContext(PageContext);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const relayState = searchParams.get('RelayState');

  useEffect(() => {
    if (!CookieUtil.isUserExpired()) {
      void navigate(`/sso${relayState ? getFullRedirect(location) : ''}`, {
        replace: true,
      });
    }

    setTitle('Axiom Law - Login');
  }, []);

  if (!CookieUtil.isUserExpired()) {
    return <Loader type="logo" expand="fullscreen" />;
  }

  return (
    <DefaultLayout sideImageUrl={sideImageUrl}>
      <Grid centered>
        <GridRow>
          <GridColumn largeScreenWidth={9} tabletWidth={9} mobileWidth={12}>
            <Gutter bottom="24px" className="text-align-center">
              <AxiomLogo width="230px" />
            </Gutter>
            <Gutter bottom="24px">
              <SmallHeader>Let's find your Axiom account</SmallHeader>
            </Gutter>
            <Gutter bottom="24px">
              <CondensedLarge>
                We'll confirm that your Axiom account is associated with this
                email.
              </CondensedLarge>
            </Gutter>
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn largeScreenWidth={9} tabletWidth={9} mobileWidth={12}>
            <Form
              initialValues={{}}
              name="EMAIL_FORM"
              onSubmit={formData => {
                void navigate(getUrlWithRelayState(`./${formData.email}`));
              }}
              schema={readAuthRequestSchema}
            >
              {({ fireSubmit }) => {
                return (
                  <>
                    <Gutter bottom="16px">
                      <Input name="email" label="Email" />
                    </Gutter>
                    <Button fluid onClick={fireSubmit} name="next-button">
                      Find my account
                    </Button>
                  </>
                );
              }}
            </Form>
          </GridColumn>
        </GridRow>
      </Grid>
    </DefaultLayout>
  );
};
